<template>
  <div class="columns">
    <div class="column">
      <b-field label="Verpackung">
        <multiselect v-model="package_code_contains" :show-labels="false"
                     placeholder="Verpackungsart auswählen"
                     :options="packages" :multiple="false" track-by="id" label="name" @select="sendConditionData"
                     :close-on-select="true"></multiselect>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Stückzahl größer">
        <b-input type=number v-model="quantity_bg" @change.native="sendConditionData"></b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Stückzahl kleiner gleich">
        <b-input type=number maxlength="255" v-model="quantity_sm_eq" @change.native="sendConditionData"></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  props: ['item'],
  components: {Multiselect},
  data() {
    return {
      package_code_contains: '',
      quantity_bg: 0,
      quantity_sm_eq: 0,
      packages: [{"id": "VP-0-0", "name": "keine Verpackung"}, {"id": "VP-FS", "name": "Faltschachtel"},
        {"id": "VP-KSE", "name": "Klarsichtetui"}, {"id": "VP-MB", "name": "Metallbox"}, {
          "id": "VP-SDS",
          "name": "Stülpdeckelschachtel"
        }],
    }
  },
  watch: {},
  mounted() {
    if (this.item && this.item.data) {
      console.log('Component ruleConditionPackageAndQuantity mounted.');
      this.package_code_contains = this.packages.find(el => el.id == this.item.data.package_code_contains)
      this.quantity_bg = this.item.data.quantity_bg
      this.quantity_sm_eq = this.item.data.quantity_sm_eq
    }
    if (!this.package_code_contains) {
      this.package_code_contains = {"id": "VP-0-0", "name": "keine Verpackung"}
    }
  },
  methods: {
    sendConditionData: function () {
      console.log('sendConditionData')
      let conditionData = {
        type: 1,
        package_code_contains: this.package_code_contains.id,
        quantity_bg: this.quantity_bg,
        quantity_sm_eq: this.quantity_sm_eq
      }
      this.$emit('setConditionData', conditionData)
    },
  },
}

</script>
